(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-cards"] && !window.DesignMode) return;
  try {
    
const container = document.querySelector('.video-cards-container');
const prevButton = document.querySelector('.video-cards-navigation .prev');
const nextButton = document.querySelector('.video-cards-navigation .next');

if (container && prevButton && nextButton) {
function smoothScroll(element, distance, duration) {
  let start = element.scrollLeft;
  let startTime = performance.now();

  function animation(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = progress * (2 - progress);

    element.scrollLeft = start + distance * ease;

    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

nextButton.addEventListener('click', () => {
  smoothScroll(container, container.clientWidth / 2, 600); 
});

prevButton.addEventListener('click', () => {
  smoothScroll(container, -container.clientWidth / 2, 600); 
});

window.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowRight') {
    smoothScroll(container, container.clientWidth / 2, 600);
  } else if (e.key === 'ArrowLeft') {
    smoothScroll(container, -container.clientWidth / 2, 600);
  }
});

}

  } catch(e) { console.error(e); }
})();
})();
